"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildCatDisplayMap = void 0;
function buildCatDisplayMap(categories) {
  var resultMap = {};
  function _build(current) {
    resultMap[current.name] = current.display;
    for (var _i = 0, _a = current.items || []; _i < _a.length; _i++) {
      var sub = _a[_i];
      _build(sub);
    }
  }
  for (var _i = 0, categories_1 = categories; _i < categories_1.length; _i++) {
    var topLevel = categories_1[_i];
    _build(topLevel);
  }
  return resultMap;
}
exports.buildCatDisplayMap = buildCatDisplayMap;